import { Outlet, useLocation } from "react-router-dom";

/**
 * Vùng nội dung bên phải.
 *
 * Chỉ component nhỏ này theo dõi URL. Nhờ vậy khi chuyển trang, phần khung menu
 * (AppShell) hoàn toàn đứng yên, không bị vẽ lại — thanh menu sáng lên tức thì
 * và không bao giờ phải "đợi" dữ liệu trang mới.
 *
 * Chỉ riêng vùng nội dung này tự cuộn (main giữ khung cố định, khối bên trong
 * mới cuộn). Nhờ vậy khối logo "NewLexBaby" ở menu trái luôn đứng yên, không bị
 * đẩy sát mép trên màn hình hay cắt mất khi thủ kho cuộn trang.
 */
export default function RouteContent() {
  const { pathname } = useLocation();

  return (
    <main className="flex min-w-0 flex-1 flex-col overflow-hidden pt-14 lg:pt-0">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <div
          key={pathname}
          className="animate-page-fade mx-auto w-full max-w-6xl px-4 py-6 md:px-8"
        >
          <Outlet />
        </div>
      </div>
    </main>
  );
}